let obj = {};
// 保险期限
obj.guarantPre = [
  {
    key: '1',
    value: '1个月'
  },
  {
    key: '3',
    value: '3个月'
  },
  {
    key: '6',
    value: '6个月'
  },
  {
    key: '12',
    value: '12个月'
  }
];
obj.sexOptions = [
  {
    value: 'M',
    name: '男'
  },
  {
    value: 'F',
    name: '女'
  }
];
obj.IdTypeOptions = [
  {
    name: '身份证',
    value: '01'
  },
  {
    name: '护照',
    value: '02'
  },
  {
    name: '其它',
    value: '99'
  }
]
obj.occupationOptionsLevel = [
  {
    value: '1',
    name: "1类",
  },
  {
    value: '2',
    name: "2类",
  },
  {
    value: '3',
    name: "3类",
  },
  {
    value: '4',
    name: "4类",
  },
  {
    value: '5',
    name: "5类",
  },
  {
    value: '特殊职业',
    name: "特殊职业",
  },
]
obj.numberLIst =[
  {
    oKind: "1类",
    oKey: "1类",
    pNum: 0
  },
  {
    oKind: "2类",
    oKey: "2类",
    pNum: 0
  },
  {
    oKind: "3类",
    oKey: "3类",
    pNum: 0
  },
  {
    oKind: "4类",
    oKey: "4类",
    pNum: 0
  },
  {
    oKind: "5类",
    oKey: "5类",
    pNum: 0
  },
  {
    oKind: "特殊职业",
    oKey: "S类",
    pNum: 0
  }
]
obj.SCPDOptions = [
  //伤残评定
  {
    value: 1,
    name: "行标评残"
  },
  {
    value: 0.32,
    name: "社保评残（十级 3%起）-不免工伤认定书"
  }, 
  {
    value: 0.31,
    name: "社保评残（十级 3%起）-免工伤认定书"
  },
  {
    value: 0.52,
    name: "社保评残（十级 5%起）-不免工伤认定书"
  },
  {
    value: 0.51,
    name: "社保评残（十级 5%起）-免工伤认定书"
  },
  {
    value: 0.1,
    name: "社保评残（十级 10%起）-不免工伤认定书"
  }
]
//轨道交通意外
obj.GDJTYWOptions = [
  {
    value: 0,
    name: "不附加"
  },
  {
    value: 100000,
    name: "10万"
  },
  {
    value: 200000,
    name: "20万"
  },
  {
    value: 300000,
    name: "30万"
  },
  {
    value: 400000,
    name: "40万"
  },
  {
    value: 500000,
    name: "50万"
  },
  {
    value: 600000,
    name: "60万"
  },
  {
    value: 700000,
    name: "70万"
  },
  {
    value: 800000,
    name: "80万"
  },
  {
    value: 900000,
    name: "90万"
  },
  {
    value: 1000000,
    name: "100万"
  }
]
//轮船意外
obj.LCJTYWOptions = [
  {
    value: 0,
    name: "不附加"
  },
  {
    value: 100000,
    name: "10万"
  },
  {
    value: 200000,
    name: "20万"
  },
  {
    value: 300000,
    name: "30万"
  },
  {
    value: 400000,
    name: "40万"
  },
  {
    value: 500000,
    name: "50万"
  },
  {
    value: 600000,
    name: "60万"
  },
  {
    value: 700000,
    name: "70万"
  },
  {
    value: 800000,
    name: "80万"
  },
  {
    value: 900000,
    name: "90万"
  },
  {
    value: 1000000,
    name: "100万"
  }
]
//营运车辆意外
obj.YYKCYWOptions = [
  {
    value: 0,
    name: "不附加"
  },
  {
    value: 100000,
    name: "10万"
  },
  {
    value: 200000,
    name: "20万"
  }
]
export default { ...obj };
